import {POCTool} from '../models/IPOCToolWebPortal';

export const poctoolCategoriesToDisplayBySearch = (
  pointOfCareTool: POCTool,
  searchQuery: string,
) => {
  if (searchQuery === '') return pointOfCareTool.categories;
  const upperCaseSearchQuery = searchQuery.toUpperCase();
  const pointOfCareToolToDisplay = pointOfCareTool.categories.filter(
    category =>
      category.name.toUpperCase().includes(upperCaseSearchQuery) ||
      category.content?.some(
        content =>
          content.contentText.toUpperCase().includes(upperCaseSearchQuery) ||
          content.type.toUpperCase().includes(upperCaseSearchQuery) ||
          content.contentURL.toUpperCase().includes(upperCaseSearchQuery),
      ) ||
      category.topics?.some(
        topic =>
          topic.name.toUpperCase().includes(upperCaseSearchQuery) ||
          topic.content?.some(
            content =>
              content.contentText
                .toUpperCase()
                .includes(upperCaseSearchQuery) ||
              content.type.toUpperCase().includes(upperCaseSearchQuery) ||
              content.contentURL.toUpperCase().includes(upperCaseSearchQuery),
          ) ||
          topic.subTopics?.some(
            subTopic =>
              subTopic.name.toUpperCase().includes(upperCaseSearchQuery) ||
              subTopic.content?.some(content =>
                content.contentText
                  .toUpperCase()
                  .includes(upperCaseSearchQuery),
              ) ||
              subTopic.content?.some(
                content =>
                  content.type.toUpperCase().includes(upperCaseSearchQuery) ||
                  content.contentURL
                    .toUpperCase()
                    .includes(upperCaseSearchQuery),
              ),
          ),
      ),
  );
  return pointOfCareToolToDisplay;
};
